import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ValidateUrl } from '../validators/url.validator';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-subscription-form',
  templateUrl: './subscription-form.component.html',
  styleUrls: ['./subscription-form.component.css']
})
export class SubscriptionFormComponent implements OnInit {

  userForm;

  buttonDisabled: boolean = false;
  loading: boolean = false;
  politics: boolean = false;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private cd: ChangeDetectorRef, public dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      company: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      url: ['', [Validators.required, ValidateUrl]],
      file: [null],
      recaptchaReactive: ['', Validators.required]
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000,
      verticalPosition: 'top',
      panelClass: ['response-snackbar']
    });
  }

  onSubmit() {

    this.buttonDisabled = true;
    this.loading = true;

    
    if (this.userForm.valid && this.politics) {

      const headers = new HttpHeaders().set('from', 'onexoform');

      this.http.post('https://api-registrar.onexo.com.br/api/user/create', this.userForm.value, { headers, responseType: 'text' })
        .subscribe((response) => {
          console.log('response ', response);
          this.openSnackBar(response, 'OK');
          this.buttonDisabled = false;
          this.loading = false;
          if (response === "Conta criada com sucesso, em breve você receberá um e-mail com os dados de acesso :)") {
            this.userForm.reset();
            window.location.href = "https://materiais.onexo.com.br/boas-vindas-teste";
          }
        })

      /*
     this.http.post('http://127.0.0.1:8180/api/user/create', this.userForm.value,{ headers, responseType: 'text'})
     .subscribe((response)=>{
       console.log('response ',response);
       this.openSnackBar(response, 'OK');
       this.buttonDisabled = false;
       this.loading = false;
       if(response === "Conta criada com sucesso, em breve você receberá um e-mail com os dados de acesso :)"){
         this.userForm.reset();
       }
     })
     */
    } else {
      this.openSnackBar(this.userForm.valid && !this.politics ? "Você precisa concordar com os termos para registrar." : "Foram encontrados dados inconsistentes. Verifique os campos em vermelho.", "OK")
      this.buttonDisabled = false;
      this.loading = false;
    }
  }

  onFileChange(event) {
    let reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.userForm.patchValue({
          file: reader.result
        });

        // need to run CD since file load runs outside of zone
        this.cd.markForCheck();
      };
    }
  }


}
